import React, { useEffect, useState } from 'react';
import api from '@/services/api';

// Busca textos de apoio existentes (por título ou trecho) para reuso N:N: em vez
// de recriar o mesmo texto em cada questão, o autor anexa um já cadastrado.
export default function MotivatorTextPicker({ onSelect }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (query.length < 3) {
      setResults([]);
      return undefined;
    }
    const timer = setTimeout(async () => {
      try {
        // O interceptor do api já devolve o corpo da resposta (documento JSON:API),
        // então `res.data` é o array de recursos motivator_text.
        const res = await api.get('/motivator_texts', { params: { q: query } });
        setResults(res?.data || []);
      } catch (e) {
        setResults([]);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [query]);

  return (
    <div className="motivator-text-picker">
      <input
        placeholder="Buscar texto de apoio existente (título ou trecho)…"
        value={query}
        onChange={e => setQuery(e.target.value)}
      />
      <ul>
        {results.map(r => (
          <li key={r.id}>
            <button
              type="button"
              onClick={() => onSelect({ id: Number(r.id), ...r.attributes })}
            >
              <strong>{r.attributes?.title || 'Sem título'}</strong>
              <span>{(r.attributes?.body || '').replace(/<[^>]+>/g, '').slice(0, 120)}…</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
